import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule, UrlPathValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        updating: false,
        loadingJournals: false,
        loadingPage: false,
        title: "",
        url: "",
        journalId: "",
        ordering: "",
        keywords: "",
        description: "",
        body: "",
        errors: {},
        journals: [],
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadJournals = instance => {
    instance.setState({
        ...instance.state,
        loadingJournals: true
    })

    let criteria = {}

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/journal/journals",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            offset: 0,
            limit: 100,
            criteria: criteria
        }
    }).then(response => handleLoadJournalsResponse(instance, response))
        .catch(error => alert(error))
}

const handleLoadJournalsResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingJournals: false,
                journals: response.data.data.journals
            })
            break
        default:
            instance.setState({
                ...instance.state,
                loadingJournals: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const loadPage = instance => {
    instance.setState({
        ...instance.state,
        loadingPage: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/journal/page",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then(response => handleLoadPageResponse(instance, response))
        .catch(error => alert(error))
}

const handleLoadPageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingPage: false,
                title: response.data.data.page.title,
                url: response.data.data.page.url,
                ordering: response.data.data.page.ordering,
                journalId: response.data.data.page.journal.id,
                keywords: response.data.data.page.keywords,
                description: response.data.data.page.description,
                body: response.data.data.page.body,
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                loadingPage: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.journalId, (error) => errors.journalId = error, { min: { value: 20, error: "Too short" }, max: { value: 45, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.title, (error) => errors.title = error, { min: { value: 2, error: "Too short" }, max: { value: 20, error: "Too long" } })
    validation.addValidationRule(UrlPathValidationRule, instance.state.url, (error) => errors.url = error, { allowNull: false })
    validation.addValidationRule(StringValidationRule, instance.state.keywords, (error) => errors.keywords = error, { min: { value: 0, error: "Too short" }, max: { value: 100, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.description, (error) => errors.description = error, { min: { value: 0, error: "Too short" }, max: { value: 300, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.ordering, (error) => errors.ordering = error, { min: { value: 1, error: "Too low" }, max: { value: 5000, error: "Too high" } })
    validation.addValidationRule(StringValidationRule, instance.state.body, (error) => errors.body = error, { min: { value: 5, error: "Too short" }, max: { value: 100000, error: "Too long" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const updatePage = (instance) => {
    instance.setState({
        ...instance.state,
        updating: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/journal/page/update",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id,
            title: instance.state.title,
            url: instance.state.url,
            ordering: instance.state.ordering,
            journalId: instance.state.journalId,
            keywords: instance.state.keywords,
            description: instance.state.description,
            body: instance.state.body
        }
    }).then(response => handleUpdatePageResponse(instance, response))
        .catch(error => alert(error))
}

const handleUpdatePageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "success",
                    text: "Page Updated"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const UpdatePageWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        loadJournals: () => loadJournals(instance),
        loadPage: () => loadPage(instance),
        updatePage: () => updatePage(instance)
    }
}

export default UpdatePageWorker